const getGnomadExomes = (state) =>
  state.variantResult && state.variantResult.gnomad_exomes;

const getGnomadExomesCoverage = (state) =>
  state.variantResult && state.variantResult.gnomad_exomes_coverage;

const getGnomadGenomes = (state) =>
  state.variantResult && state.variantResult.gnomad_genomes;

const getGnomadGenomesCoverage = (state) =>
  state.variantResult && state.variantResult.gnomad_genomes_coverage;

const getIsbKaviar3 = (state) =>
  state.variantResult && state.variantResult.isb_kaviar3;

const getBravo = (state) => state.variantResult && state.variantResult.bravo;

const getMitomap = (state) =>
  state.variantResult && state.variantResult.mitomap;

const getGnomadMito = (state) =>
  state.variantResult && state.variantResult.gnomad_mito;

const isMitochondriac = (state) => {
  if (state.variantResult && state.variantResult?.chromosome) {
    if (
      state.variantResult?.chromosome === "chrM" ||
      state.variantResult?.chromosome === "MT"
    ) {
      return true;
    }
  }
  return false;
};

const getSelectedReferenceGenomeId = (state) => state.genome && state.genome.id;

export {
  getGnomadExomes,
  getGnomadExomesCoverage,
  getGnomadGenomes,
  getGnomadGenomesCoverage,
  getIsbKaviar3,
  getBravo,
  getMitomap,
  getGnomadMito,
  isMitochondriac,
  getSelectedReferenceGenomeId,
};
